module.exports = __webpack_public_path__ + "static/img/_1.64d16afc.png";